import { useDevices } from "@/store/devices";
import { getCameraStationCount } from "@/store/devices/selectors";
import { usePremiumScreen } from "@/modules/app/PremiumScreen";
import { useRequester } from "./useRequester";

const MAX_FREE_CAMERA_STATIONS = 3;

export const useOpenPairingWizard = () => {
  const { wizard } = useRequester();
  const { displayBannerForFreeUser } = usePremiumScreen();
  const cameraStationCount = useDevices(getCameraStationCount);

  return () => {
    if (cameraStationCount >= MAX_FREE_CAMERA_STATIONS) displayBannerForFreeUser("more_cameras").elseRun(wizard.open);
    else wizard.open();
  };
};
